import { createSlice } from "@reduxjs/toolkit";
import {
  createBillingSettings,
  getBillingSettingsById,
  updateBillingSettings,
} from "./BillingSettingsForm.thunk";

const baseState = {
  billingSettingsData: null,
  billingSettingsId: null,
  merchantId: null,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusRetrieve: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusCreate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  statusUpdate: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  errorRetrieve: null,
  errorCreate: null,
  errorUpdate: null,
};

const initialState = {
  ...baseState,
};

export const billingSettingsFormSlice = createSlice({
  name: "billingSettingsForm",
  initialState,
  reducers: {
    setMerchantId: (state, action) => {
      state.merchantId = action.payload;
    },
    ResetStore: (state) => {
      return { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBillingSettingsById.pending, (state) => {
        state.statusRetrieve = "loading";
        state.errorRetrieve = null;
      })
      .addCase(getBillingSettingsById.fulfilled, (state, action) => {
        const { billingSettingsData, merchantId } = action.payload;
        state.billingSettingsData = { ...billingSettingsData };
        state.billingSettingsId = billingSettingsData?.id || billingSettingsData?.ID || null;
        state.merchantId = merchantId;
        state.statusRetrieve = "succeeded";
        state.errorRetrieve = null;
      })
      .addCase(getBillingSettingsById.rejected, (state, action) => {
        state.statusRetrieve = "failed";
        state.errorRetrieve =
          action.payload?.message || "Error retrieving billing settings";
        state.billingSettingsData = null;
      });
    builder
      .addCase(createBillingSettings.pending, (state) => {
        state.statusCreate = "loading";
        state.errorCreate = null;
      })
      .addCase(createBillingSettings.fulfilled, (state) => {
        state.statusCreate = "succeeded";
        state.errorCreate = null;
        state.merchantId = null;
        state.billingSettingsData = null;
        state.billingSettingsId = null;
      })
      .addCase(createBillingSettings.rejected, (state, action) => {
        state.statusCreate = "failed";
        state.errorCreate =
          action.payload?.message || "Error creating billing settings";
      });
    builder
      .addCase(updateBillingSettings.pending, (state) => {
        state.statusUpdate = "loading";
        state.errorUpdate = null;
      })
      .addCase(updateBillingSettings.fulfilled, (state) => {
        state.statusUpdate = "succeeded";
        state.errorUpdate = null;
      })
      .addCase(updateBillingSettings.rejected, (state, action) => {
        state.statusUpdate = "failed";
        state.errorUpdate =
          action.payload?.message || "Error updating billing settings";
      });
  },
});

export const { setMerchantId, ResetStore } =
  billingSettingsFormSlice.actions;

export default billingSettingsFormSlice.reducer;
